// Carry out various operations related to organising shifts
(function () {
  angular.module('calendarApp').service('ShiftService', ShiftService);

  function ShiftService() {
    // Take a list of shifts and:
    //  - group by resource
    //  - order by date
    this.getShiftsByResource = function (shifts, appointments) {
      var shiftObject = {};
      shifts.forEach(function (shift) {
        for (var i = 0; i < shift.timeslots.length; i++) {
          if (appointments && appointments.length) {
            for (var i = 0; i < appointments.length; i++) {
              if (appointments[i].serviceid === shift.timeslots[i].serviceid && appointments[i].resourceid === shift.timeslots[i].resourceid && appointments[i].start === shift.timeslots[i].start && appointments[i].end === shift.timeslots[i].end) {
                shift.timeslots[i].selected = shift.timeslots[i].selected ? shift.timeslots[i].selected + 1 : 1;
              } else {
                shift.timeslots[i].selected = 0;
              }
            }
          } else {
            shift.timeslots[i].selected = 0;
          }
        }

        if (shift.hasresource) {
          if (typeof shiftObject[shift.resourceid] === 'undefined') {
            shiftObject[shift.resourceid] = {
              resource: shift.resource,
              shifts: [shift],
              timeslots: shift.timeslots
            };
          } else {
            shiftObject[shift.resourceid].shifts.push(shift);
          }
        } else {
          if (typeof shiftObject['no-resource'] === 'undefined') {
            shiftObject['no-resource'] = {
              resource: {
                name: ''
              },
              shifts: [shift],
              timeslots: shift.timeslots
            };
          } else {
            shiftObject['no-resource'].shifts.push(shift);
          }
        }
      }); // End foreach

      return shiftObject;
    };
  }
})();